/**
 * Paramètre anti-cache des rechargements de mise à jour, et son nettoyage.
 *
 * ⚠️ CE MODULE NETTOIE L'URL À SON IMPORT. Ce n'est pas un oubli.
 *
 * Vue Router capte window.location dès l'évaluation de createWebHistory(),
 * c'est-à-dire à l'import de src/router - donc avant la moindre instruction de
 * main.js, les imports ES étant tous évalués en premier. Un nettoyage appelé
 * depuis le corps de main.js arrive trop tard : le routeur a déjà mémorisé
 * l'URL avec le paramètre et le rétablit au montage. Constaté au test.
 *
 * D'où l'effet de bord à l'import, et l'obligation d'importer ce module AVANT
 * '@/router' dans main.js.
 *
 * Volontairement sans aucune dépendance (ni IndexedDB, ni Vue) : il est chargé
 * au tout début du boot, avant que quoi que ce soit d'autre ne soit prêt.
 */

const PARAM_MAJ = '__maj';

/**
 * Construit l'URL de rechargement post-mise-à-jour.
 *
 * Le paramètre est indispensable : les postes du parc ont reçu index.html avec
 * un `expires max` (10 ans) avant le correctif nginx du 2 août 2026. Leur cache
 * HTTP resservirait l'ancien index.html indéfiniment, même sans service worker.
 * Une URL jamais vue est le seul moyen sûr de forcer une requête réseau.
 */
function urlAvecParamMaj(versionCible) {
    const url = new URL(window.location.href);
    url.searchParams.set(PARAM_MAJ, `${versionCible}-${Date.now()}`);
    return url.toString();
}

/**
 * Retire le paramètre de la barre d'adresse sans recharger. Sans cela il
 * resterait collé à l'URL et se retrouverait recopié dans les liens partagés
 * (QR de panier, de menu, d'enrôlement d'un serveur).
 *
 * @returns {boolean} vrai si un paramètre a été retiré.
 */
function nettoyerUrlApresMaj() {
    try {
        const url = new URL(window.location.href);
        if (!url.searchParams.has(PARAM_MAJ)) return false;

        url.searchParams.delete(PARAM_MAJ);
        window.history.replaceState(
            window.history.state,
            '',
            url.pathname + url.search + url.hash
        );
        return true;
    } catch (e) {
        // URL exotique ou history indisponible : un paramètre résiduel est
        // sans gravité, il ne doit surtout pas empêcher le boot.
        return false;
    }
}

// Effet de bord assumé : voir l'en-tête du fichier.
nettoyerUrlApresMaj();

export { PARAM_MAJ, urlAvecParamMaj, nettoyerUrlApresMaj };
